// Module for creating service url
// Usage:
// var serviceUrl = require('./modules/service-url')('/destination/path');

module.exports = function serviceUrl(url) {
  var environment = require('./../../../../../inc/environment.json');

  // URL constructor doesn't work in IE8
  var parser = window.location;

  if (parser.host == environment.corp_url) {
    return 'https://' + environment.service_url + url;
  }

  var stageUrlReg = /stage(-[1-9])?-www\.yinxiang\.com/g;
  if (stageUrlReg.test(parser.hostname)) {
    return 'https://' + parser.hostname.replace('-www', '') + url;
  }

  // Fallback if above fails
  switch(parser.hostname) {
    case 'www-china.evernote.com':
      return 'https://stage-china.evernote.com'+url;
    case 'stage-www.yinxiang.com':
      return 'https://stage.yinxiang.com'+url;
    case 'stage-8-www.yinxiang.com':
      return 'https://stage-8.yinxiang.com'+url;
    case 'stage-9-www.yinxiang.com':
      return 'https://stage-9.yinxiang.com'+url;
    case 'www.yinxiang.com':
      return 'https://app.yinxiang.com'+url;
    case 'yinxiang.com':
      return 'https://app.yinxiang.com'+url;
    case 'evernote.com':
      return 'https://www.evernote.com'+url;
    case 'www.preprod2.evernote.com':
      return 'https://app.preprod2.evernote.com'+url;
    case 'v2-corp.zoo.etonreve.com':
      return 'https://v2.zoo.etonreve.com'+url;
    default:
      return 'https://stage.evernote.com'+url;
  }
};



// WEBPACK FOOTER //
// ./webroot/yinxiang/media/js/modules/service-url.js